// eslint:disable max-line-length
import * as React from 'react';
import { PresentationType } from 'app/components/favourite-layout';
import {
  tableOptions, tileOptions, tileAttributeMappings, tableAttributeMappings,
  heatmapOptions, heatmapAttributeMappings, chartLayoutAttributes, pieOptions,
  pieAttributeMappings, columnAndBarOptions, columnAttributeMappings, barAttributeMappings, MIN_NO_OF_CRITERIAS, areaOptions,
  areaAttributeMappings, riskReportOptions, riskReportAttributeMappings
} from './constants';
import { LayoutAttributesSelector } from './attributes-selector';
import { AttributesPickerTranslation } from './types';
import { chartType } from 'app/components/favourite-layout/constants';

export interface AttributesPickerProps {
  presentationType: number;
  layoutAttributes: { [key: string]: string | boolean };
  onAttributeChange: (value: { [key: string]: string | boolean | number }[]) => void;
  translations: Partial<AttributesPickerTranslation>;
  numberOfGroupByFields?: number;
}

export const AttributesPicker = (props: AttributesPickerProps) => {

  if (props.presentationType === PresentationType.Table) {
    return <LayoutAttributesSelector
      options={tableOptions}
      attributesMapping={tableAttributeMappings}
      layoutAttributes={props.layoutAttributes}
      onChange={props.onAttributeChange}
      translations={props.translations}
    />;
  }

  if (props.presentationType === PresentationType.Tile) {
    return <LayoutAttributesSelector
      options={tileOptions}
      attributesMapping={tileAttributeMappings}
      layoutAttributes={props.layoutAttributes}
      onChange={props.onAttributeChange}
      translations={props.translations}
    />;
  }

  if (props.presentationType === PresentationType.Highcharts
    && props.layoutAttributes[chartLayoutAttributes.heatmapType]) {
    return <LayoutAttributesSelector
      options={heatmapOptions}
      attributesMapping={heatmapAttributeMappings}
      layoutAttributes={props.layoutAttributes}
      onChange={props.onAttributeChange}
      translations={props.translations}
    />;
  }

  if (props.presentationType === PresentationType.Highcharts
    && props.layoutAttributes[chartLayoutAttributes.chartType] === chartType.PIE) {
    return <LayoutAttributesSelector
      options={pieOptions}
      attributesMapping={pieAttributeMappings}
      layoutAttributes={props.layoutAttributes}
      onChange={props.onAttributeChange}
      translations={props.translations}
    />;
  }

  if (props.presentationType === PresentationType.Highcharts
    && props.layoutAttributes[chartLayoutAttributes.chartType] === chartType.COLUMN
    && props.numberOfGroupByFields >= MIN_NO_OF_CRITERIAS) {
    return <LayoutAttributesSelector
      options={columnAndBarOptions}
      attributesMapping={columnAttributeMappings}
      layoutAttributes={props.layoutAttributes}
      onChange={props.onAttributeChange}
      translations={props.translations}
    />;
  }

  if (props.presentationType === PresentationType.Highcharts
    && props.layoutAttributes[chartLayoutAttributes.chartType] === chartType.BAR
    && props.numberOfGroupByFields >= MIN_NO_OF_CRITERIAS) {
    return <LayoutAttributesSelector
      options={columnAndBarOptions}
      attributesMapping={barAttributeMappings}
      layoutAttributes={props.layoutAttributes}
      onChange={props.onAttributeChange}
      translations={props.translations}
    />;
  }

  if (props.presentationType === PresentationType.Highcharts
    && props.layoutAttributes[chartLayoutAttributes.chartType] === chartType.AREA
    && props.numberOfGroupByFields >= MIN_NO_OF_CRITERIAS) {
    return <LayoutAttributesSelector
      options={areaOptions}
      attributesMapping={areaAttributeMappings}
      layoutAttributes={props.layoutAttributes}
      onChange={props.onAttributeChange}
      translations={props.translations}
    />;
  }

  if (props.presentationType === PresentationType.RiskReport) {
    return <LayoutAttributesSelector
      options={riskReportOptions}
      attributesMapping={riskReportAttributeMappings}
      layoutAttributes={props.layoutAttributes}
      onChange={props.onAttributeChange}
      translations={props.translations}
    />;
  }

  return null;
};
